export default __webpack_public_path__ + "static/media/IMG_00004.4518453f.jpeg";